import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function ProtectedRoute({ children, requireAdmin = false, roles = null }) {
  const { user } = useAuth();
  const location = useLocation();

  if (user === null) {
    return (
      <div
        className="min-h-screen bg-[#050505] text-zinc-500 font-body flex items-center justify-center"
        data-testid="auth-loading"
      >
        Vérification...
      </div>
    );
  }

  if (!user) {
    const redirect = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?redirect=${redirect}`} replace />;
  }

  const homeFor = (role) =>
    role === "organizer" ? "/organizer" : role === "coach" ? "/coach" : "/admin";

  // Explicit role whitelist (e.g. ["admin", "organizer"])
  if (roles && !roles.includes(user.role)) {
    return <Navigate to={homeFor(user.role)} replace />;
  }

  // Admin-only routes redirect coaches/organizers to their own dashboard
  if (!roles && requireAdmin && user.role !== "admin") {
    return <Navigate to={homeFor(user.role)} replace />;
  }

  return children;
}
